
import axios from "axios";
import { defineComponent, provide, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import { errManager } from "@/core/config/Tools";
import VisorFile from "../modals/general/VisorFile.vue";

export default defineComponent({
  name: "file3",
  props: {
    fileTitle: String,
    createdAt: String,
    fileType: String,
    download: Boolean,
    file: String,
    method: String,
    buttons: Object,
    company: String
  },
  components: { VisorFile },
  setup(props){
    const loading = ref(false)
    const { t } = useI18n();
    const urlFile = ref<String>('');
    const open_dialog_view_file = ref<boolean>(false);
    provide('urlFile', urlFile);
    provide('open_dialog_view_file', open_dialog_view_file);

    const handlerFile = async(id: string | number) => {
      if(props.method == 'download')
        await DownloadFile(`${props.file}?type=${id}&company=${props.company}`);
      else
        await handlerViewFile();
    }

    const handlerViewFile = () => {
      urlFile.value = props.file?.toString() || '';
      open_dialog_view_file.value = true;
      console.log(open_dialog_view_file.value);
    }

    const DownloadFile = (file) => {
            //VUE_APP_API_URL
            loading.value = true
            axios({
                url: file,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                loading.value = false
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fURL = document.createElement('a');
                var nameFile = props.fileTitle + "." + props.fileType

                fURL.href = fileURL;
                fURL.setAttribute('download', nameFile);
                document.body.appendChild(fURL);
                //this.$Progress.finish();
                fURL.click();
            }).catch(({response}) => {
              loading.value = false
                errManager(response);
            })
        }

    /*const Download = (file) => {
      alert(file)
    }*/

    return{
      t,
      loading,
      handlerFile,
      DownloadFile,
      handlerViewFile,
    }
  }
});
